<template>
    <div class="main-status-setting">
        <CreateChannelModal :create_channel.sync="modals.create_channel"  v-on:closeModal="closeModal()" :hubList="hubList"  />
        <CreatePlatformModal :create_platform.sync="modals.create_platform"  v-on:closeModal="closePlatformModal()" />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Channel Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <!-- <base-button v-show="backButton" type="primary" icon size="sm" @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </base-button> -->
                    <b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">

            <SourceChannelTable :hubList="hubList"></SourceChannelTable>

            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Platform Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="openPlatformModal">Create New</b-button>
                </b-col>
            </b-row>

            <PlatformTable :hubList="hubList"></PlatformTable>

        </b-container>
    </div>
</template>

<script>
import { Tabs, TabPane } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import MainStatusSettingTable from '@/views/Configurations/MainStatusSettings/MainStatusTable'
import CreateChannelModal from './Modals/CreateChannelModal.vue'
import CreatePlatformModal from '@/views/Configurations/PlatformSettings/Modals/CreatePlatformModal'
import SourceChannelTable from './SourceChannelTable.vue'
import PlatformTable from '@/views/Configurations/PlatformSettings/PlatformTable.vue'
import {
    axios,
    services,
    getHeader,
		helperFunctionMixin
} from '@/assets/js/httpImports.js'
import CreatePlatformModalVue from '../PlatformSettings/Modals/CreatePlatformModal.vue'


export default {
		mixins:[
        helperFunctionMixin
    ],
    components: {
        CreateChannelModal,
        MainStatusSettingTable,
        PlatformTable,
        SourceChannelTable,
        RouteBreadCrumb,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        CreateChannelModal,
        CreatePlatformModal
    },
    data() {
        return {
            modals:{
                create_channel: false,
                create_platform: false,
            },
            backButton: false,
            hubList: [],
        };
    },
    created() {
        if(this.$route.params.token)
        {
            this.backButton = true;
        }
        // this.fetchHub()
    },
    methods: {
        close() {
            if(this.$route.params.token)
            {
                // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                window.history.back();
                window.close();
            }
            else
            {
                this.$router.back();
            }
        },
        openModal() {
            this.modals.create_channel = true;
        },
        openPlatformModal() {
            this.modals.create_platform = true;
        },
        closeModal(){
            this.modals.create_channel = false;
        },
        closePlatformModal(){
            this.modals.create_platform = false
        },
        fetchHub(){
					if(this.checkRoleType(['admin'])  && this.checkAppCode('sas')){
            axios.get(services.hub + 'hubs', { headers: getHeader() })
            .then(res => {
                this.hubList = res.data.data
                this.$emit('closeModal', false)
            })
            .catch(e => {
                console.log(e)
                this.errorFunction(e)
            })
					}	
        },
    }
}
</script>